/**
 * Created by Vladislav on 31.03.2025.
 */

const SwitchButton = cleverapps.Spine.extend({
    avoidNode: "SwitchButton",

    ctor: function () {
        this._super(bundles.merge.jsons.switch_button);

        this.setAnimation(0, Merge2.current.mode === Merge2.MODE_META ? "idle_meta" : "idle_game", true);

        this.startAttentionAnimation();

        Merge2.current.on("changeMode", this.onChangeMode.bind(this));
        cleverapps.meta.getSelectedLocation().on("changeStars", this.stopAttentionAnimation.bind(this));

        Merge2.current.on("stop", this.stopAttentionAnimation.bind(this), this);

        cleverapps.UI.onClick(this, this.onClicked.bind(this), {
            interactiveScale: false
        });
    },

    onChangeMode: function (mode) {
        mode = mode || Merge2.current.mode;
        if (mode === Merge2.MODE_META) {
            this.setAnimationAndIdleAfter("transition_to_meta", "idle_meta");
            this.stopAttentionAnimation();
        } else {
            this.setAnimationAndIdleAfter("transition_to_game", "idle_game");
            this.startAttentionAnimation();
        }
    },

    onClicked: function () {
        if (Merge2.current.counter.isActive() || this.switching) {
            return;
        }

        const action = function (f) {
            cleverapps.effects.fire("merge2.scene.switch");

            const scene = cleverapps.Scenes.GetRunningScene();
            const sideBar = ComponentUtils.findComponentByName(scene, "SideBarController");
            const metaControls = ["toolbar"];
            if (sideBar) {
                metaControls.push(...sideBar.getControls());
            }

            if (Merge2.current.mode === Merge2.MODE_GAME) {
                cleverapps.focusManager.hideControlsWhileFocused(["backpackButton", "unitInfoView"]);
                cleverapps.focusManager.showControlsWhileFocused(metaControls);

                Merge2.current.changeMode(Merge2.MODE_META, f);
            } else {
                cleverapps.focusManager.hideControlsWhileFocused(metaControls);
                cleverapps.focusManager.showControlsWhileFocused(["backpackButton", "unitInfoView"]);

                Merge2.current.changeMode(Merge2.MODE_GAME, f);
            }
        };

        if (cleverapps.tutorial.isActive()) {
            this.switching = true;

            action(() => {
                this.switching = false;

                cleverapps.tutorial.trigger("switchButton");
            });

            return;
        }

        cleverapps.focusManager.display({
            focus: "SwitchButton",
            keepControls: true,
            actions: [
                action,

                (f) => {
                    cleverapps.rewardedAdsManager.showInterstitial({
                        limit: AdsLimits.TYPES.INTERSTITIAL,
                        placement: AdsLimits.TYPES.INTERSTITIAL_OTHER
                    }, f);
                }
            ]
        });
    },

    startAttentionAnimation: function () {
        this.stopAttentionAnimation();

        const location = cleverapps.meta.getSelectedLocation();
        const hasEnoughStars = location.stars.getAmount() >= location.calcStarsForStage();

        if (hasEnoughStars && Merge2.current.mode === Merge2.MODE_GAME) {
            this.attentionTimeout = cleverapps.timeouts.setTimeout(() => {
                if (Math.random() < 0.4) {
                    this.setAnimationAndIdleAfter("attention", "idle_game");
                }
                this.startAttentionAnimation();
            }, 3500);
        }
    },

    stopAttentionAnimation: function () {
        if (this.attentionTimeout !== undefined) {
            cleverapps.timeouts.clearTimeout(this.attentionTimeout);
            delete this.attentionTimeout;
        }

        if (this.attention) {
            this.attention.removeFromParent();
            delete this.attention;
        }
    },

    onResize: function () {
        if (this.attention) {
            this.attention.setScale(cleverapps.resolution.isVertical() ? 1.5 : 1);
        }
    }
});